import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  ngOnInit(): void {
    //throw new Error('Method not implemented.');
    let a = (document.getElementsByTagName('html') as HTMLCollectionOf<HTMLHtmlElement>)[0];
    if(window.innerWidth  > 769 ){
      var percentageOn1 = window.innerWidth / 1920;
      a.style.zoom=""+(percentageOn1*100)+"%";
    }
    else{
      a.style.zoom="100%"
    }
  }

}
